module.exports = __webpack_public_path__ + "img/3.8214b70b.jpg";